import React from 'react';
import { Eyebrow } from '../components/xc/Bits';
import { IMAGES } from '../mock/data';
import { ScanFace, Radar, ShieldAlert, Lock, ShieldCheck, FileCheck2 } from 'lucide-react';

const CARDS = [
  { icon: ScanFace, title: 'KYC VERIFIED', color: '#B026FF', text: 'Identity and age verification are handled by the regulated casino layer.' },
  { icon: Radar, title: 'AML MONITORING', color: '#FF204E', text: 'Player and transaction activity is monitored for unusual financial patterns.' },
  { icon: ShieldAlert, title: 'XINTINEL', color: '#E0B85A', featured: true, text: "Xintinel is Xincity's event-driven fraud and AML monitoring layer. It combines known rules, behavioural changes, linked-account analysis and pattern similarity to create explainable review alerts." },
  { icon: Lock, title: 'FRAUD DETECTION', color: '#B026FF', text: 'Account takeover, multi-account abuse, reward farming and suspicious networks can be identified for review.' },
  { icon: ShieldCheck, title: 'RESPONSIBLE GAMBLING', color: '#2FBF71', text: 'Limits, safer-play controls and self-exclusion always override mission mechanics.' },
  { icon: FileCheck2, title: 'AUDITABLE', color: '#FF204E', text: 'Sensitive decisions remain evidence-backed and reviewable.' },
];

export default function Trust() {
  return (
    <div className="bg-[#070609] min-h-screen">
      <section className="relative overflow-hidden border-b border-white/5">
        <img src={IMAGES.penthouse3} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 city-overlay" />
        <div className="relative max-w-[1200px] mx-auto px-4 lg:px-8 py-16">
          <Eyebrow color="#B026FF">Trust &amp; Safety</Eyebrow>
          <h1 className="font-display font-700 text-4xl md:text-5xl text-white tracking-tight">SAFE. SECURE. <span className="text-gradient-rp">ACCOUNTABLE.</span></h1>
          <p className="mt-3 text-white/60 max-w-2xl">Compliance, player protection and fraud monitoring are core to the Xincity architecture. This page explains how the pieces fit together — the full Xintinel analyst dashboard is a future build.</p>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-4 lg:px-8 py-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.map((c) => (
            <div key={c.title} className={`xc-card rounded-2xl p-6 relative overflow-hidden ${c.featured ? 'sm:col-span-2 lg:col-span-1 lg:row-span-1' : ''}`} style={c.featured ? { borderColor: `${c.color}55` } : {}}>
              {c.featured && <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full opacity-20 blur-3xl" style={{ background: c.color }} />}
              <div className="h-12 w-12 rounded-xl grid place-items-center mb-4" style={{ background: `${c.color}16`, border: `1px solid ${c.color}44` }}><c.icon className="h-6 w-6" style={{ color: c.color }} /></div>
              <h3 className="font-display font-700 text-white tracking-wide">{c.title}</h3>
              <p className="mt-2 text-sm text-white/55 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-2xl overflow-hidden xc-glass border border-white/8">
          <div className="grid md:grid-cols-2">
            <div className="p-8">
              <div className="text-xs tracking-[0.2em] uppercase text-white/40 mb-3">How it fits together</div>
              <h3 className="font-display font-700 text-2xl text-white">The casino stays compliant. Xincity stays accountable.</h3>
              <p className="mt-3 text-white/55 leading-relaxed text-sm">The regulated casino layer owns accounts, wallets, payments, KYC, AML and responsible-gambling infrastructure. Xincity reacts to trusted settled events and layers social progression on top — with Xintinel watching for fraud and abuse the whole time.</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {['Provider Game', 'Settled Event', 'Casino Platform', 'Xincity + Xintinel'].map((s, i) => (
                  <span key={i} className="text-xs px-3 py-1.5 rounded-full bg-white/[0.04] border border-white/10 text-white/70">{s}</span>
                ))}
              </div>
            </div>
            <div className="relative min-h-[240px]"><img src={IMAGES.neonCity} alt="" className="absolute inset-0 h-full w-full object-cover" /><div className="absolute inset-0" style={{ background: 'linear-gradient(90deg,#151119,transparent)' }} /></div>
          </div>
        </div>
      </section>
    </div>
  );
}
